/* eslint-disable camelcase, eqeqeq, jsx-a11y/no-noninteractive-element-interactions */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import TimeDateCard from '../../postjob/rolecard/TimeDateCard';
import RoleDetailCard from '../../postjob/rolecard/RoleDetailCard';
import { toggleCalendar, toggleOptionCard } from '../../../actions/ViewController';
import { updateField } from '../../../actions/BookingRequest';
import { validateValue } from '../../common/Utils';
import { TRootState } from '../../../reducers';
import { RoleIcon } from '../../postjob/rolecard/RoleIcon';
import { TServiceKey } from '../../../types';
import { jobModes } from '../../../consts';

export default function RoleCard() {
    const dispatch = useDispatch();

    const mode = jobModes.CREATE;
    const [withHelper, setWithHelper] = useState(false);

    const {
        date,
        minStart,
        roleData,
        rolePopout,
        service,
        servicesStructure,
    } = useSelector((state: TRootState) => ({
        date: state.requestData.bookingRequest.date,
        minStart: state.requestData.minStart,
        roleData: state.requestData.roleData,
        rolePopout: state.view.rolePopout,
        service: state.requestData.bookingRequest.service as TServiceKey,
        servicesStructure: state.servicesStructure,
    }));

    useEffect(() => {
        setTimeout(() => setWithHelper(true), 3000);
    }, []);

    useEffect(() => {
        if (service && date) {
            setTimeout(() => setWithHelper(false), 3000);
        }
    }, [service, date]);

    const isMinStartToday = () => moment(minStart).isSame(new Date(), 'day');

    const todayOrTomorrowSelected = () => {
        if (!validateValue(date)) return false;

        if (isMinStartToday()) {
            return moment(date).isSame(new Date(), 'day');
        }
        return moment(date).subtract(1, 'days').isSame(new Date(), 'day');
    };

    const otherDaySelected = () => {
        if (!validateValue(date)) return false;

        return !todayOrTomorrowSelected();
    };

    const fieldChange = (e: any) => {
        if (e.target.name === 'service') {
            dispatch(updateField('service', e.target.value));
            // if (handleSwipe) handleSwipe(1); TODO
        } else if (e.target.name === 'date') {
            const todayDate = moment(new Date());
            if (e.target.value === 'today') {
                dispatch(updateField('date', todayDate.format('YYYY-MM-DD')));
                dispatch(toggleOptionCard());
            } else if (e.target.value === 'tomorrow') {
                dispatch(updateField('date', todayDate.add(1, 'days').format('YYYY-MM-DD')));
                dispatch(toggleOptionCard());
            } else {
                dispatch(toggleOptionCard('time'));
            }
            dispatch(toggleCalendar(e.target.value));
            // if (this.props.handleSwipe) this.props.handleSwipe(2); TODO
        }
    };

    const otherDate = otherDaySelected()
        ? moment(date, 'YYYY-MM-DD').format('DD MMM')
        : 'Choose a day';

    const handleRoleFieldClick = useCallback(
        (serviceKey: string) => {
            dispatch(toggleOptionCard('role'));
            dispatch(updateField('service', serviceKey));
        },
        [dispatch],
    );

    const renderRoleIcons = () => {
        if (servicesStructure) {
            return Object.entries(servicesStructure)
                .filter(([serviceKey, serviceData]) => !!serviceKey && serviceData.client_enabled !== false)
                .map(([serviceKey, serviceData]) =>
                    <RoleIcon
                        key={serviceKey}
                        value={serviceKey}
                        handleChange={() => handleRoleFieldClick(serviceKey)}
                        roleItemClassName="role-item service-role-item"
                        name={serviceData.label}
                        iconName={serviceData.icon_name}
                        service_key={service}
                        mode={mode}
                        activeLabelOnClick={() => handleRoleFieldClick(serviceKey)}
                    />
                );
        }
        return null;
    };

    const tooltipText = () => {
        if (service) {
            if (date) {
                return 'Let\'s go!';
            }
            return 'Select a date';
        }
        return 'Select a role';
    };

    return (
        <div className={`card-wrapper
            ${rolePopout.shiftTimes || rolePopout.roleExtras ? ' expanded' : ''}
            ${service ? ' oneline-selected' : ''}
            ${date ? ' date-selected' : ''}
            ${withHelper ? '' : ' without-helper'}`}
        >
            <div className="select-toolip">
                {tooltipText()}
            </div>
            <div className="card card-role card-role-main">
                <div className="card-content">
                    <p className="card-title">Role</p>
                    <form className="form-roles">
                        {renderRoleIcons()}
                    </form>
                    <form className="form-date">
                        <div className={`role-item${todayOrTomorrowSelected() ? ' active' : ''}`}>
                            {isMinStartToday() ? (
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="date"
                                        value="today"
                                        onChange={fieldChange}
                                    />
                                    <span>Today</span>
                                </label>
                            ) : (
                                <label className="item-circle-wrapper">
                                    <input
                                        type="checkbox"
                                        name="date"
                                        value="tomorrow"
                                        onChange={fieldChange}
                                    />
                                    <span>Tomorrow</span>
                                </label>
                            )}
                        </div>
                        <div className={`role-item${otherDaySelected() ? ' active' : ''}`}>
                            <label
                                className="item-circle-wrapper"
                                onClick={fieldChange}
                            >
                                <input
                                    type="checkbox"
                                    name="date"
                                    value="choose"
                                    onChange={fieldChange}
                                />
                                <span>{otherDate}</span>
                            </label>
                        </div>
                    </form>
                </div>
            </div>
            {rolePopout.roleExtras && (
                <RoleDetailCard
                    service_key={service}
                    roleData={roleData}
                    displayRoleIcon={false}
                />
            )}
            {rolePopout.shiftTimes && (
                <TimeDateCard
                    calendarOnly={true}
                    updateField={updateField}
                />
            )}
        </div>
    );
}
